(() => {
  'use strict';
  const key = 'mayamaroc.cod.orders.v1';
  const config = JSON.parse(document.getElementById('mm-orders-config')?.textContent || '{}');
  const labels = config.labels || {};
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value.filter(o => o && typeof o.id === 'string' && Array.isArray(o.items)).slice(0,100) : [];
    } catch (_) { return []; }
  };
  const clean = value => String(value ?? '').slice(0,300);
  const imageURL = value => {
    try { const u = new URL(value, location.origin); return u.protocol === 'https:' && /(^|\.)shopify\.com$/.test(u.hostname) ? u.href : ''; } catch (_) { return ''; }
  };
  const number = value => { const n = Number(value); return Number.isFinite(n) && n >= 0 ? n : null; };
  function capture(order, product) {
    if (!order || !order.id || !Array.isArray(order.line_items) || !order.line_items.length) return;
    const id = clean(order.id);
    const items = order.line_items.map(item => {
      const main = String(item.product_id) === String(product?.id);
      return { title: clean(item.title || item.name || (main ? product.title : '')), variant: clean(item.variant_title === 'Default Title' ? '' : item.variant_title), quantity: Math.max(1,Math.floor(number(item.quantity) || 1)), price: number(item.price), image: imageURL(item.image?.src || item.image || (main ? product.image : '')) };
    });
    const date = Date.parse(order.created_at);
    const entry = { id, name: clean(order.name || (order.order_number ? '#' + order.order_number : '')), createdAt: Number.isFinite(date) ? new Date(date).toISOString() : new Date().toISOString(), total: number(order.total_price), currency: /^[A-Z]{3}$/.test(order.currency || '') ? order.currency : config.currency || 'MAD', items };
    const orders = read();
    const index = orders.findIndex(o => o.id === id);
    if (index < 0) orders.unshift(entry); else orders[index] = entry;
    try { localStorage.setItem(key, JSON.stringify(orders.slice(0,100))); } catch (_) { return; }
    render();
  }
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const money = (amount,currency) => {
    try { return new Intl.NumberFormat(config.locale || 'fr',{style:'currency',currency}).format(amount); } catch (_) { return String(amount) + ' ' + currency; }
  };
  function render() {
    const orders = read();
    document.querySelectorAll('[data-mm-order-count]').forEach(node => { node.textContent = String(orders.length); node.hidden = !orders.length; });
    const list = document.querySelector('[data-mm-orders-list]');
    if (!list) return;
    list.replaceChildren();
    const empty = document.querySelector('[data-mm-orders-empty]');
    if (empty) empty.hidden = !!orders.length;
    orders.forEach(order => {
      const card = element('article','mm-history-card');
      const head = element('div','mm-history-card__head');
      head.append(element('h2','',labels.order + (order.name ? ' ' + order.name : '')));
      head.append(element('span','mm-history-status',labels.success));
      card.append(head);
      const date = new Date(order.createdAt);
      if (Number.isFinite(date.getTime())) { const time = element('time','mm-history-date',date.toLocaleDateString(config.locale || 'fr',{year:'numeric',month:'long',day:'numeric'})); time.dateTime = date.toISOString(); card.append(time); }
      order.items.forEach(item => {
        const row = element('div','mm-history-product');
        const image = imageURL(item.image);
        if (image) { const img = element('img'); img.src=image; img.alt=item.title; img.loading='lazy'; img.width=92; img.height=92; row.append(img); }
        const info = element('div','mm-history-product__info');
        info.append(element('h3','',item.title));
        if (item.variant) info.append(element('p','',item.variant));
        info.append(element('p','',labels.quantity + ' : ' + item.quantity));
        row.append(info); card.append(row);
      });
      if (order.total !== null) card.append(element('p','mm-history-total',labels.total + ' : ' + money(order.total,order.currency)));
      card.append(element('p','mm-history-confirmation',labels.wait));
      list.append(card);
    });
  }
  window.MMRecordCODOrder = order => capture(order,config.product);
  (window.MMOrderQueue || []).forEach(order => capture(order,config.product));
  window.MMOrderQueue = [];
  window.addEventListener('storage', event => { if (event.key === key) render(); });
  window.addEventListener('pageshow',render);
  document.addEventListener('shopify:section:load',render);
  render();
})();
